/**
 * 付款區通知信箱欄的前端檢查。後端以 is_email() 為準，這裡只擋空白與明顯不像信箱的值。
 * @param {unknown} value
 * @returns {string} 錯誤訊息；合法回空字串
 */
export function notifyEmailError(value) {
    var email = typeof value === 'string' ? value.trim() : '';
    if (email === '') {
        return '請填寫電子郵件地址';
    }
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? '' : '電子郵件地址格式不正確';
}
